import { useState } from "react";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { formatApiError, LOGO_URL } from "../../lib/api";
import { toast } from "sonner";
import { ArrowRight, Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Sesión iniciada");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-ink-900 flex items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute inset-0 grid-lines opacity-30" />
      <div className="absolute inset-0 bg-gradient-to-t from-ink-900 via-transparent to-transparent" />

      <div className="relative w-full max-w-md">
        <Link to="/" className="inline-flex items-center mb-12">
          <img
            src={LOGO_URL}
            alt="DoSoft"
            className="h-14 w-auto object-contain"
            style={{ filter: "brightness(0) invert(1)" }}
          />
        </Link>

        <div className="border border-ink-500 bg-ink-800 p-10">
          <div className="flex items-center gap-3 mb-2">
            <Lock size={18} strokeWidth={1.5} className="text-brand" />
            <h1 className="font-display font-bold text-2xl text-ash-100">Acceso restringido</h1>
          </div>
          <p className="text-ash-300 text-sm mb-8">Inicia sesión para gestionar leads, cotizaciones y proyectos.</p>

          <form onSubmit={submit} data-testid="admin-login-form" className="space-y-5">
            <label className="block">
              <span className="text-xs font-semibold text-ash-300 uppercase tracking-widest mb-2 block">Email</span>
              <input
                data-testid="admin-input-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-ink-900 border border-ink-500 text-ash-100 focus:border-brand focus:ring-1 focus:ring-brand outline-none px-4 py-3"
              />
            </label>
            <label className="block">
              <span className="text-xs font-semibold text-ash-300 uppercase tracking-widest mb-2 block">Contraseña</span>
              <input
                data-testid="admin-input-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-ink-900 border border-ink-500 text-ash-100 focus:border-brand focus:ring-1 focus:ring-brand outline-none px-4 py-3"
              />
            </label>
            <button
              data-testid="admin-login-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-brand text-ink-800 font-semibold hover:bg-brand-hover px-6 py-4 uppercase tracking-wider text-sm flex items-center justify-center gap-3 disabled:opacity-50"
            >
              {loading ? "Verificando…" : "Iniciar sesión"} <ArrowRight size={16} />
            </button>
          </form>
        </div>

        <Link to="/" className="block text-center mt-6 text-xs uppercase tracking-widest text-ash-300 hover:text-brand">
          ← Volver al sitio
        </Link>
      </div>
    </div>
  );
}
